import React from 'react';
import { Plane } from 'lucide-react';
import { loadingStages, aviationQuotes } from './pdfConstants';

const PDFLoadingScreen = ({ loadingStage, loadingProgress, currentQuote, displayName }) => {
  const CurrentLoadingIcon = loadingStages[loadingStage].icon;
  const currentLoadingText = loadingStages[loadingStage].text;
  const currentLoadingColor = loadingStages[loadingStage].color;
  const quote = aviationQuotes[currentQuote];

  return (
    <div className="absolute inset-0 z-50 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col items-center justify-center">
      <div className="absolute inset-0 overflow-hidden opacity-10">
        {[...Array(5)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse"
            style={{
              left: `${20 + i * 15}%`,
              top: `${10 + i * 20}%`,
              animationDelay: `${i * 0.5}s`
            }}
          >
            <Plane className="h-16 w-16 text-teal-400 transform rotate-45" />
          </div>
        ))}
      </div>
      
      <div className="relative z-10 text-center px-8 max-w-2xl">
        <div className="relative mb-8">
          <div className="absolute inset-0 bg-teal-500/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="relative bg-gradient-to-br from-teal-500 to-cyan-500 p-8 rounded-full shadow-2xl shadow-teal-500/30">
            <CurrentLoadingIcon className={`h-16 w-16 text-white ${loadingStage === 3 ? 'animate-bounce' : 'animate-pulse'}`} />
          </div>
        </div>
        
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-2 line-clamp-2">
          {displayName}
        </h2>
        
        <p className={`text-lg ${currentLoadingColor} mb-6 transition-all duration-500`}>
          {currentLoadingText}
        </p>
        
        <div className="w-full max-w-md mx-auto mb-8">
          <div className="h-2 bg-slate-700 rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-teal-500 via-cyan-400 to-teal-500 rounded-full transition-all duration-500 relative"
              style={{ width: `${Math.min(loadingProgress, 100)}%` }}
            >
              <div className="absolute inset-0 bg-white/20 animate-pulse"></div>
            </div>
          </div>
          <p className="text-sm text-slate-400 mt-2">
            {Math.round(loadingProgress)}% completado
          </p>
        </div>
        
        <div className="bg-slate-800/50 backdrop-blur-sm rounded-xl p-6 border border-slate-700/50">
          <p className="text-slate-300 italic text-lg mb-2">
            "{quote.quote}"
          </p>
          <p className="text-teal-400 text-sm font-medium">
            — {quote.author}
          </p>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-0 right-0 text-center">
        <p className="text-slate-500 text-sm">
          Biblioteca Tecnica Aeronautica - C&M Servicios Aeronauticos
        </p>
      </div>
    </div>
  );
};

export default PDFLoadingScreen;
